import { Route, Switch, useRouteMatch } from "react-router-dom";
import NotificationsPage from "../pages/Notifications";
import NotificationsSettingsPage from "../pages/Notifications/NotificationsSettingsPage";

function NotificationsSettingsPageRoutes(): JSX.Element {
  const match = useRouteMatch();

  return (
    <div className="w-full h-full">
      <Switch>
        <Route exact path={match.path} component={NotificationsPage} />
        <Route
          path={`${match.path}/settings`}
          component={NotificationsSettingsPage}
        />
      </Switch>
    </div>
  );
}

export default NotificationsSettingsPageRoutes;
